/**
 * Number of free preset planet images available (asset files
 * `planet_1.png` … `planet_{FREE_PLANET_IMAGE_COUNT}.png` under
 * `apps/client/src/assets/images/planets/`). `Planet.planetType` is a
 * 1-indexed selector into this range — `UpdatePlanetSchema` rejects
 * anything above it, so only these are actually assignable today.
 */
export const FREE_PLANET_IMAGE_COUNT = 6;
/**
 * Total number of preset planet image assets that exist on disk. Ids above
 * `FREE_PLANET_IMAGE_COUNT` are premium: they render locked in the picker
 * until unlocked with Dark Matter (`unlockPlanetImage`), after which they are
 * assignable like any free image (see `premium.schemas.ts` / the
 * `updatePlanet` handler's entitlement gate).
 */
export const TOTAL_PLANET_IMAGE_COUNT = 18;
//# sourceMappingURL=planets.js.map